var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7613 6.46747C20.6223 5.81687 21.3973 5.03614 22 4.1253C21.225 4.47229 20.3209 4.73253 19.4168 4.81928C20.364 4.25542 21.0528 3.38795 21.3973 2.30361C20.5362 2.8241 19.546 3.21446 18.5558 3.43133C17.6947 2.52048 16.5323 2 15.2407 2C12.7436 2 10.7202 4.03855 10.7202 6.55422C10.7202 6.9012 10.7632 7.24819 10.8493 7.59518C7.10372 7.37831 3.7456 5.55663 1.50685 2.8241C1.11937 3.4747 0.90411 4.25542 0.90411 5.12289C0.90411 6.68434 1.67906 8.07229 2.92759 8.89639C2.19569 8.85301 1.4638 8.67952 0.861057 8.33253V8.3759C0.861057 10.588 2.41096 12.4096 4.4775 12.8434C4.13307 12.9301 3.70254 13.0169 3.31507 13.0169C3.0137 13.0169 2.75538 12.9735 2.45401 12.9301C3.0137 14.7518 4.69276 16.053 6.67319 16.0964C5.12329 17.3108 3.18591 18.0482 1.07632 18.0482C0.688845 18.0482 0.344423 18.0048 0 17.9614C1.98043 19.2627 4.34834 20 6.93151 20C15.2407 20 19.7613 13.1036 19.7613 7.0747C19.7613 6.85783 19.7613 6.68434 19.7613 6.46747Z",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bc8e1d4d0c4c52602434c3cea1cd8ac4.svg";
export { ForwardRef as ReactComponent };